import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenUtil } from '../core/services/TokenUtil.service';
import { ConnectionService } from '../modules/organization/connection.service';
import { AuthServiceService } from '../shared/services/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MCPServerService {
  totalMCPServerCount: number = 0;
  isExecuting: boolean;
  constructor(
    private token: TokenUtil,
    private http: HttpClient,
    public connectionService: ConnectionService,
    public authService: AuthServiceService,
    private _snackBar: MatSnackBar
  ) { }


  //set total server count
  async checkAndSetServerCount() {
    if (this.totalMCPServerCount == 0) {
      let res = await this.getMCPServerByWorkspaceId();
      this.totalMCPServerCount = res?.totalCount;
    } else {
      this.totalMCPServerCount = Number(this.totalMCPServerCount) + 1;
    }
  }
  /**
 *  get mcp server by workspace id
 * @param workspace 
 * @returns 
 */
  async getMCPServerByWorkspaceId() {
    var url = `${environment.SERVER_BASE_URL}/mcp-server/${this.connectionService.setWorkspaceId()}`;
    var options = { headers: { Authorization: `PreAuthenticatedToken ${this.connectionService.preAuthenticatedToken}` } }
    try {
      let response: any = await this.http.get(url, options).toPromise();
      console.log("[mcp] get response:", response);
      return response;
    } catch (e) {
      console.error("[mcp] Error on get mcp:", JSON.stringify(e));
      throw e;
    }
  }

  /**
   *  get mcp server by id
   * @param id 
   * @returns 
   */
  async getMCPServerById(id: any) {
    var url = `${environment.SERVER_BASE_URL}/mcp-server/id/${id}`;
    var options = { headers: { Authorization: `PreAuthenticatedToken ${this.connectionService.preAuthenticatedToken}` } }
    try {
      let response: any = await this.http.get(url, options).toPromise();
      console.log("[mcp] get response:", response);
      const sever = response?.data;
      return sever;
    } catch (e) {
      console.error("[mcp] Error on get mcp:", JSON.stringify(e));
      throw e;
    }
  }

  /**
   * Delete mcp server by id
   * @param id 
   * @returns 
   */
  async deleteMCPServerById(id: any) {
    let url = `${environment.SERVER_BASE_URL}/mcp-server/${id}`;
    var options = { headers: { Authorization: `PreAuthenticatedToken ${this.connectionService.preAuthenticatedToken}` } }
    try {
      let response: any = await this.http.delete(url, options).toPromise();
      console.log("[mcp] delete response:", response);
      return response;
    } catch (e) {
      console.error("[mcp] Error on delete mcp:", JSON.stringify(e));
      throw e;
    }
  }

  /**
   *  create mcp server
   * @param body 
   * @returns 
   */
  async createMCPServer(body?: any) {
    console.log("printing create", body)
    var options = { headers: { Authorization: `PreAuthenticatedToken ${this.connectionService.preAuthenticatedToken}` } }

    var url = `${environment.SERVER_BASE_URL}/mcp-server`
    try {
      let response: any = await this.http.post(url, body, options).toPromise();
      console.log("create server response", response);
      return response.data[0]
    } catch (e) {
      console.error("[BOX-HTTP] Error on create mcp server:", e)
      throw e;
    }
  }

  /**
   *  update mcp server
   * @param body 
   * @returns 
   */
  async updateMCPServer(body?: any) {
    console.log("printing update", body)
    var options = { headers: { Authorization: `PreAuthenticatedToken ${this.connectionService.preAuthenticatedToken}` } }

    var url = `${environment.SERVER_BASE_URL}/mcp-server`
    try {
      let response: any = await this.http.put(url, body, options).toPromise();
      console.log("update server response", response);
      return response.data[0]
    } catch (e) {
      console.error("[BOX-HTTP] Error on create mcp server:", e)
      throw e;
    }
  }

}
